// src/AccessDenied/AccessDenied.js
import React from 'react';

const AccessDenied = () => (
  <div style={{ textAlign: 'center', padding: '2rem' }}>
    <h1>403 - Access Denied</h1>
    <p>You do not have permission to view this page.</p>
  </div>
);

export default AccessDenied;
